import { APIService } from "@kluntje/services";
import { appendQueryParams } from "@kluntje/js-utils/lib/url-helpers";
import { HOUR_IN_MS } from "Constants/dateConstants";

import { LocalEventsApiResponse, LocalEventsServiceQueryOptions } from "./LocalEventsService.types";

class LocalEventsService {
  private get apiUrl() {
    return "https://fde-events.rwdhub.de/v1/events/";
  }

  public async getEvents(options?: LocalEventsServiceQueryOptions): Promise<LocalEventsApiResponse | null> {
    return APIService.fetchJSON<LocalEventsApiResponse>(this.getQueryUrl(options), {
      cacheOptions: {
        validFor: HOUR_IN_MS,
      },
    });
  }

  private getQueryUrl(options?: LocalEventsServiceQueryOptions): string {
    if (options === undefined) return this.apiUrl;

    const params: URLSearchParams = new URLSearchParams();
    if (options.locations) {
      options.locations.forEach(location => {
        params.append("location", location);
      });
    }

    if (options.pageSize) {
      params.append("size", options.pageSize.toString());
    }

    if (options.page) {
      const offset = (options.pageSize ?? 10) * (options.page - 1);
      params.append("offset", offset.toString());
    }

    return appendQueryParams(this.apiUrl, params);
  }
}

export default new LocalEventsService();
